(function(){
  var d=document;
  function $(s,c){return (c||d).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}
  // mobile drawer
  var drawer=$('#drawer');
  $$('[data-open-drawer]').forEach(function(b){b.addEventListener('click',function(){drawer&&drawer.classList.add('is-open')})});
  $$('[data-close-drawer]').forEach(function(b){b.addEventListener('click',function(){drawer&&drawer.classList.remove('is-open')})});
  // search toggle
  var sp=$('#search-panel');
  $$('[data-toggle-search]').forEach(function(b){b.addEventListener('click',function(){
    if(!sp)return;sp.classList.toggle('is-open');var i=$('input',sp);if(sp.classList.contains('is-open')&&i)i.focus();
  })});
  // gallery
  $$('[data-gallery]').forEach(function(g){
    var main=$('[data-gallery-main] img',g);
    $$('[data-thumb]',g).forEach(function(t){t.addEventListener('click',function(){
      if(main){main.src=t.getAttribute('data-src');main.srcset=''}
      $$('[data-thumb]',g).forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active');
    })});
  });
  // quantity
  $$('[data-qty]').forEach(function(q){
    var i=$('input',q);
    $$('button',q).forEach(function(b){b.addEventListener('click',function(){
      var v=parseInt(i.value||'1',10)+(b.getAttribute('data-dir')==='up'?1:-1);i.value=Math.max(1,v);
      i.dispatchEvent(new Event('change',{bubbles:true}));
    })});
  });
  // variant switching: find matching variant from selected options
  $$('[data-product-form]').forEach(function(f){
    var json=$('[data-variants]',f);if(!json)return;
    var variants=JSON.parse(json.textContent);
    var idInput=$('[name=id]',f),priceEl=$('[data-price]'),addBtn=$('[data-add]',f),buyBtn=$('[data-buy]',f);
    function update(){
      var sel=$$('[data-option]',f).map(function(o){
        if(o.tagName==='SELECT')return o.value;
        var c=$('input:checked',o);return c?c.value:null;
      });
      var m=variants.filter(function(v){return v.options.every(function(x,i){return x===sel[i]})})[0];
      if(!m){return}
      idInput.value=m.id;
      if(priceEl)priceEl.innerHTML=m.price_html;
      [addBtn,buyBtn].forEach(function(b){if(b){b.disabled=!m.available}});
      if(addBtn)addBtn.textContent=m.available?addBtn.getAttribute('data-label'):'Unavailable';
      if(buyBtn)buyBtn.textContent=m.available?'Buy now':'Unavailable';
      var u=new URL(location.href);u.searchParams.set('variant',m.id);history.replaceState({},'',u);
    }
    f.addEventListener('change',update);
  });
  // filters auto submit
  $$('[data-filter-form]').forEach(function(f){
    f.addEventListener('change',function(){f.submit()});
  });
  $$('[data-sort]').forEach(function(s){s.addEventListener('change',function(){
    var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u;
  })});
  // cart qty auto-update
  $$('[data-cart-form] input[name^="updates"]').forEach(function(i){i.addEventListener('change',function(){i.form.submit()})});
})();
